<template>
    <SimpleTable formclass="User/form" endpoint="users" :aditionalColumns="headers" inlineToggle>
        <template>
            <h1>Cadastro de Usuários</h1>
            <v-divider class="mb-4"></v-divider>
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
export default {
    components: {
        SimpleTable,
    },
    data() {
        return {
            headers: [
                { text: this.$t("Habilitado"), value: "enable", align: "right", sortable: false },
                { text: this.$t("Nome"), value: "name", align: "right", sortable: true },
            ],
        };
    },
};
</script>